import { Spinner } from '@george-labs.com/design-system';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { FormPhoneInput } from './FormPhoneInput';
import type { LibphoneApi } from './LiphoneApiTypes';
import type { FormFieldProps } from '../types/FormFieldProps';

interface Props extends FormFieldProps {
    disabled?: boolean;
    info?: string;
    autoFocus?: boolean;
}
export const LazyFormPhoneInput: FC<Props> = ({
    fieldName,
    autoFocus,
    disabled,
    info,
    'data-cy': dataCy,
}) => {
    const [libphoneApi, setLibphoneApi] = useState<LibphoneApi>();
    useEffect(() => {
        import('libphonenumber-js/max').then(
            ({
                getExampleNumber,
                isSupportedCountry,
                parsePhoneNumberFromString,
                getCountryCallingCode,
            }) => {
                setLibphoneApi({
                    getExampleNumber,
                    isSupportedCountry,
                    parsePhoneNumberFromString,
                    getCountryCallingCode,
                });
            },
        );
    }, []);

    if (!libphoneApi) {
        return <Spinner size={Spinner.SIZE.SMALL} />;
    }

    return (
        <FormPhoneInput
            libphoneApi={libphoneApi}
            fieldName={fieldName}
            disabled={disabled}
            autoFocus={autoFocus}
            data-cy={dataCy}
            info={info}
        />
    );
};
